import { useEffect, useState } from "react";
import { getStatus, type Status } from "./api/client";

const OPISY_MODULOW: Record<string, string> = {
  ingestion: "Pobieranie danych rynkowych, wskaznikow i newsow",
  ml: "Cechy, zbiory treningowe, trenowanie i ocena modeli",
  strategy: "Zamiana predykcji na sygnaly, portfel, limity ryzyka",
  backtest: "Symulacja strategii na danych historycznych",
  execution: "Skladanie zlecen — domyslnie tryb symulowany",
};

export default function App() {
  const [status, setStatus] = useState<Status | null>(null);
  const [blad, setBlad] = useState<string | null>(null);

  useEffect(() => {
    getStatus()
      .then(setStatus)
      .catch(() => setBlad("Nie udalo sie polaczyc z API."));
  }, []);

  return (
    <div className="app">
      <header className="header">
        <h1>InvestingApp</h1>
        <p className="podtytul">
          Hub inwestycyjny — dane, modele, sygnaly, egzekucja.
        </p>
        {status && (
          <span
            className={`znacznik-trybu ${status.execution_mode === "live" ? "tryb-live" : "tryb-paper"}`}
          >
            {status.execution_mode === "live"
              ? "TRYB LIVE — prawdziwe pieniadze"
              : "Tryb symulacji (paper)"}
          </span>
        )}
      </header>

      <main>
        {blad && <p className="blad">{blad}</p>}

        {!status && !blad && <p className="ladowanie">Laduje status...</p>}

        {status && (
          <>
            <p className="wstep">
              Szkielet aplikacji stoi. Ponizsze moduly maja przygotowane miejsce
              w repozytorium i czekaja na zaplanowanie.
            </p>
            <ul className="moduly">
              {Object.entries(status.modules).map(([nazwa, stan]) => (
                <li key={nazwa} className="modul">
                  <div className="modul-naglowek">
                    <span className="modul-nazwa">{nazwa}</span>
                    <span className="modul-stan">{stan}</span>
                  </div>
                  <p className="modul-opis">{OPISY_MODULOW[nazwa] ?? ""}</p>
                </li>
              ))}
            </ul>
          </>
        )}
      </main>

      <footer className="stopka">
        <a href="/docs">Dokumentacja API</a>
        <span aria-hidden="true"> · </span>
        <a href="/health">/health</a>
      </footer>
    </div>
  );
}
